document.addEventListener("DOMContentLoaded", () => {

    const gallery = document.createElement("div");
    gallery.id = "framelle-gallery";

    gallery.innerHTML = `
        <div id="framelle-gallery-close">&times;</div>
        <div id="framelle-gallery-prev">&#10094;</div>
        <img id="framelle-gallery-image">
        <div id="framelle-gallery-next">&#10095;</div>
    `;

    document.body.appendChild(gallery);

    let images = [];
    let current = 0;

    function loadImages(){

        images = [
    ...document.querySelectorAll(".jm-media-grid__image"),
    ...document.querySelectorAll(".jm-media-thumbnail-list__thumbnail img")
];;

        images.forEach((img,index)=>{

            img.style.cursor="zoom-in";

            img.onclick=function(e){

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();


                current=index;

                open();

                return false;
            }

        });

    }

    function open(){

        gallery.classList.add("active");

        document.body.style.overflow="hidden";

        document.getElementById("framelle-gallery-image").src =
        images[current].src.replace("width=160","width=1200");

    }

    function close(){

        gallery.classList.remove("active");

        document.body.style.overflow="";

    }

    function next(){

        current++;

        if(current>=images.length) current=0;

        open();

    }

    function prev(){

        current--;

        if(current<0) current=images.length-1;

        open();

    }

    document.getElementById("framelle-gallery-close").onclick=close;
    document.getElementById("framelle-gallery-next").onclick=next;
    document.getElementById("framelle-gallery-prev").onclick=prev;

    gallery.onclick=e=>{
        if(e.target===gallery) close();
    }

    document.addEventListener("keydown",e=>{

        if(!gallery.classList.contains("active")) return;

        if(e.key==="Escape") close();

        if(e.key==="ArrowRight") next();

        if(e.key==="ArrowLeft") prev();

    });

    loadImages();

    const observer=new MutationObserver(loadImages);

    observer.observe(document.body,{
        childList:true,
        subtree:true
    });

});